'use client'

import { ReactNode } from 'react'
import { PopoverPanel, PopoverPanelProps } from '@headlessui/react'
import { useDetectClickOutside } from '@/shared/hooks/useDetectClickOutside'

// Sometimes, headlessui's PopoverPanel does not close by merely clicking outside for some reason.
export default function NCPopoverPanel({
  children,
  ignoredOutsideClickSelectors = [],
  ...props
}: Omit<PopoverPanelProps, 'children'> & {
  children: ReactNode
  ignoredOutsideClickSelectors?: string[]
}) {
  return (
    <PopoverPanel {...props}>
      {({ close }) => (
        <PanelContent
          close={close}
          ignoredOutsideClickSelectors={ignoredOutsideClickSelectors}
        >
          {children}
        </PanelContent>
      )}
    </PopoverPanel>
  )
}

function PanelContent({
  close,
  children,
  ignoredOutsideClickSelectors,
}: {
  close: () => void
  children: ReactNode
  ignoredOutsideClickSelectors: string[]
}) {
  const ref = useDetectClickOutside<HTMLDivElement>({
    onTriggered: (event) => {
      const target = event.target

      if (
        target instanceof Element &&
        ignoredOutsideClickSelectors.some((selector) =>
          target.closest(selector),
        )
      ) {
        return
      }

      close()
    },
  })

  return <div ref={ref}>{children}</div>
}
